import TimePicker from '../date-picker2/src/picker/time-picker';
export default TimePicker;



// WEBPACK FOOTER //
// ./src/components/time-picker/index.js